// « Aide » : FAQ courte, ce qu'Ekera fait des pièces, souveraineté, contact. Texte fixe, sans appel à l'API.
import { useEkera } from '../contexte';
import { ADRESSE_CONTACT, QUESTIONS_AIDE, TEXTE_CONTACT } from '../domaine/aide';
import { rouvrirPremiersPas } from '../domaine/premiersPas';
import { naviguer } from '../routeur';
import { usePremiersPasFermes } from '../composants/PremiersPas';

export function EcranAide() {
  const { cid } = useEkera();
  const ferme = usePremiersPasFermes(cid);
  return (
    <div className="pile aide-page">
      <p className="sous-titre">Réponses courtes aux questions d’une première semaine avec Ekera.</p>
      <section className="panneau" aria-labelledby="t-aide-pas">
        <h2 id="t-aide-pas">Premiers pas</h2>
        <p>
          {ferme
            ? 'Vous avez refermé le parcours « Premiers pas » du tableau de bord. Vous pouvez le rouvrir.'
            : 'Le parcours « Premiers pas » est affiché en haut du tableau de bord.'}
        </p>
        <p>
          <button
            type="button"
            className="btn"
            onClick={() => {
              rouvrirPremiersPas(cid);
              naviguer('tableau');
            }}
          >
            {ferme ? 'Rouvrir les premiers pas' : 'Aller aux premiers pas'}
          </button>
        </p>
      </section>
      <section className="panneau" aria-labelledby="t-faq">
        <h2 id="t-faq">Questions fréquentes</h2>
        <div className="faq">
          {QUESTIONS_AIDE.map((q) => (
            <details key={q.id} id={`faq-${q.id}`}>
              <summary>{q.question}</summary>
              <div className="pile">
                {q.reponse.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </details>
          ))}
        </div>
      </section>
      <section className="panneau" aria-labelledby="t-contact">
        <h2 id="t-contact">Qui contacter ?</h2>
        <p>{TEXTE_CONTACT}</p>
        <p>
          <a className="btn principal" href={`mailto:${ADRESSE_CONTACT}`}>
            {ADRESSE_CONTACT}
          </a>
        </p>
      </section>
    </div>
  );
}
